// extracted by mini-css-extract-plugin
export default {"loading":"Documents_loading__v0I3L","placeHolderShimmer":"Documents_placeHolderShimmer__4iftk"};